import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { Button } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { TooltipModule } from 'primeng/tooltip';
import { AnnouncementsApi } from '../../../../../shared/services/api/announcements.api';
import { AnnouncementEmailStats } from '../../../../../shared/models/announcement-email-stats';

@Component({
  selector: 'app-announcement-email-stats-dialog',
  imports: [Button, TooltipModule],
  templateUrl: './announcement-email-stats-dialog.html',
  styleUrl: './announcement-email-stats-dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AnnouncementsApi],
})
export class AnnouncementEmailStatsDialog {
  public emailStats = input<AnnouncementEmailStats | null>(null);
  protected readonly dialogRef = inject(DynamicDialogRef);
}
